module.exports = __webpack_public_path__ + "img/10_42.cd1c4f73.png";